import {
  HelpCenterAccountAccessIcon,
  HelpCenterActivitiesIcon,
  HelpCenterCompaniesIcon,
  HelpCenterInventoryIcon,
  HelpCenterPipelineDealsIcon,
  HelpCenterProjectsAccessIcon,
  HelpCenterTasksIcon,
  HelpCenterWorkflowsTasksIcon,
} from "../../../../assets";
import { HelpCenterTopic } from "../models/HelpCenterTopic";

export const HELP_CENTER_URL = "https://kanaearth.atlassian.net/servicedesk/customer/portals";
export const HELP_CENTER_CONTACT_SUPPORT_URL = "https://kanaearth.atlassian.net/servicedesk/customer/portal/1/group/-1";

export const HELP_CENTER_TOPICS: HelpCenterTopic[] = [
  {
    slug: "account-access",
    title: "Account & access",
    subtitle: "Manage your account and users",
    href: "https://kanaearth.atlassian.net/servicedesk/customer/portal/1/topic/ba2b1974-14f5-44d6-98db-72c10ca0eb70",
    icon: <HelpCenterAccountAccessIcon />,
  },
  {
    slug: "activities",
    title: "Activities",
    subtitle: "Manage project activities",
    href: "https://kanaearth.atlassian.net/servicedesk/customer/portal/1/topic/e11da430-338a-48a7-b3b9-6a93282fbbcc",
    icon: <HelpCenterActivitiesIcon />,
  },
  {
    slug: "companies",
    title: "Companies",
    subtitle: "Review and update companies",
    href: "https://kanaearth.atlassian.net/servicedesk/customer/portal/1/topic/3d24d885-3918-4eab-8fcc-66082882d70a",
    icon: <HelpCenterCompaniesIcon />,
  },
  {
    slug: "inventory",
    title: "Inventory management",
    subtitle: "Track inventory and sales",
    href: "https://kanaearth.atlassian.net/servicedesk/customer/portal/1/topic/9936579e-0dda-46ca-951f-7796e3b3052d",
    icon: <HelpCenterInventoryIcon />,
  },
  {
    slug: "pipeline-deals",
    title: "Pipeline & deals",
    subtitle: "Manage pipeline and deals",
    href: "https://kanaearth.atlassian.net/servicedesk/customer/portal/1/topic/774b9943-bf25-4979-856f-3bcd8ea6f334",
    icon: <HelpCenterPipelineDealsIcon />,
  },
  {
    slug: "projects-access",
    title: "Projects & access",
    subtitle: "Review projects and access",
    href: "https://kanaearth.atlassian.net/servicedesk/customer/portal/1/topic/18642d0c-88f4-4087-a3be-322bb7144137",
    icon: <HelpCenterProjectsAccessIcon />,
  },
  {
    slug: "workflows",
    title: "Workflows",
    subtitle: "Create and manage workflows",
    href: "https://kanaearth.atlassian.net/servicedesk/customer/portal/1/topic/c3e560a6-69b0-4f06-9025-37b5de06d1d3",
    icon: <HelpCenterWorkflowsTasksIcon />,
  },
  {
    slug: "tasks",
    title: "Tasks",
    subtitle: "Create and manage tasks",
    href: "https://kanaearth.atlassian.net/servicedesk/customer/portal/1/topic/dcacd0c3-8dcd-4e62-93f2-62960d2a6395",
    icon: <HelpCenterTasksIcon />,
  },
];
